import {
  GET_MEMBERS,
  GET_INVITED_MEMBERS,
  INVITE_MEMBER,
  DELETE_MEMBER_INVITATION,
  GET_MEMBER_DETAILS,
  GET_MEMBER_WEEKLY_EARNING,
  GET_MEMBER_MONTHLY_EARNING,
  ADD_MEMBER,
  UPDATE_MEMBER,
  REMOVE_MEMBER,
  SET_PAYMENT_CONFIGURATION,
  UPDATE_PAYMENT_CONFIGURATION,
  CLEAR_MEMBER_DETAILS_DATA,
  CLEAR_MEMBER_INVITED,
  BULK_UPDATE_EMPLOYEE_TYPE,
  GET_PENDING_REQUESTS,
  REQUEST_UPDATE_EMPLOYEE_TYPE,
  BULK_UPDATE_FROM_PENDING_REQUESTS,
} from "../../modules/constants";

// ------------------------------------
// Actions
// ------------------------------------

export function getMembersList(value) {
  return {
    type: GET_MEMBERS,
    payload: value,
  };
}

export function getInvitedMembersList(value) {
  return {
    type: GET_INVITED_MEMBERS,
    payload: value,
  };
}

export function inviteMember(value) {
  return {
    type: INVITE_MEMBER,
    payload: value,
  };
}

export function deleteMemberInvitation(value) {
  return {
    type: DELETE_MEMBER_INVITATION,
    payload: value,
  };
}

export function getMemberDetails(value) {
  return {
    type: GET_MEMBER_DETAILS,
    payload: value,
  };
}

export function getMemberWeeklyEarning(value) {
  return {
    type: GET_MEMBER_WEEKLY_EARNING,
    payload: value,
  };
}

export function getMemberMonthlyEarning(value) {
  return {
    type: GET_MEMBER_MONTHLY_EARNING,
    payload: value,
  };
}

export function addMember(value) {
  return {
    type: ADD_MEMBER,
    payload: value,
  };
}

export function updateMember(value) {
  return {
    type: UPDATE_MEMBER,
    payload: value,
  };
}
export function removeMember(value) {
  return {
    type: REMOVE_MEMBER,
    payload: value,
  };
}
export function setPaymentConfiguration(value) {
  return {
    type: SET_PAYMENT_CONFIGURATION,
    payload: value,
  };
}
export function updatePaymentConfiguration(value) {
  return {
    type: UPDATE_PAYMENT_CONFIGURATION,
    payload: value,
  };
}
export function clearMemberDetailsData() {
  return {
    type: CLEAR_MEMBER_DETAILS_DATA,
  };
}
export function clearMemberInvited() {
  return {
    type: CLEAR_MEMBER_INVITED,
  }
}

export function bulkUpdateEmployeeType(payload) {
  return {
    type: BULK_UPDATE_EMPLOYEE_TYPE,
    payload,
  };
}

export function requestUpdateEmployeeType(payload) {
  return {
    type: REQUEST_UPDATE_EMPLOYEE_TYPE,
    payload,
  };
}

export function getPendingRequests(payload) {
  return {
    type: GET_PENDING_REQUESTS,
    payload,
  };
}

export function bulkUpdateFromPendingRequests(payload, status) {
  return {
    type: BULK_UPDATE_FROM_PENDING_REQUESTS,
    payload,
    status
  };
}
